import React from 'react';
import './ForecastMethodology.css';

// Import the new flowchart image
import flowchartImage from '../../assets/images/forecasting-flowchart.png';

const ForecastMethodology = () => {
  return (
    <section className="forecast-methodology-section">
      <div className="forecast-methodology-container">
        <div className="section-header">
          <h2>Our forecasting methodology</h2>
          <div className="header-line"></div>
        </div>
        <p className="section-subtitle">
          Our price forecasting mechanism uses a hybrid approach for predicting the prices of crops by combining machine learning models and sentiment analysis.
        </p>
        <p className="section-subtitle">
          It considers following key factors: cost drivers, upstream-downstream prices, global prices, supply & demand, macro-economic factors, and market sentiment.
        </p>
        
        <div className="flowchart-image-container">
          <img src={flowchartImage} alt="Forecasting methodology flowchart" />
        </div>
      </div>
    </section>
  );
};

export default ForecastMethodology;